import { TENANT_SLUG_MAX_LENGTH, TenantSlug } from "@repo/shared-types/helpdesk";

const trimDashes = (value: string): string => value.replace(/^-+|-+$/g, "");

// Suggests a slug from a tenant name. Returns "" when nothing usable remains; the caller still validates with TenantSlug.
export function suggestTenantSlug(name: string): string {
  return trimDashes(trimDashes(name.toLowerCase().replace(/[^a-z0-9]+/g, "-")).slice(0, TENANT_SLUG_MAX_LENGTH));
}

export function tenantPortalUrl(origin: string, slug: string): string {
  return `${origin}/${slug}`;
}

// Top-level SPA roots that existed before tenant prefixes; slug-less links to them belong to the internal tenant.
const LEGACY_ROOTS: ReadonlySet<string> = new Set(["admin", "approvals", "gates", "helpdesk", "profile", "timeline"]);

const LEGACY_DOCUMENT_SHARING_PATH = /^\/document-sharing\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/?$/i;

const firstSegment = (pathname: string): string => pathname.split("/")[1] ?? "";

export function slugFromPathname(pathname: string): string | null {
  const segment = firstSegment(pathname);
  return TenantSlug.safeParse(segment).success ? segment : null;
}

export function tenantPath(slug: string, path = "/"): string {
  return path === "/" || path === "" ? `/${slug}` : `/${slug}${path.startsWith("/") ? path : `/${path}`}`;
}

// Path below the tenant prefix, always starting with "/".
export function pathWithinTenant(pathname: string, slug: string): string {
  const prefix = `/${slug}`;
  if (pathname === prefix) return "/";
  return pathname.startsWith(`${prefix}/`) ? pathname.slice(prefix.length) : pathname;
}

// Maps a pre-slug SPA path to its internal-tenant equivalent, or null when the path is not a legacy SPA route.
export function legacyPath(pathname: string, internalSlug: string): string | null {
  if (!LEGACY_ROOTS.has(firstSegment(pathname)) && !LEGACY_DOCUMENT_SHARING_PATH.test(pathname)) return null;
  return tenantPath(internalSlug, pathname);
}
